class Queue {
  constructor(sortFunction) {
    this.sortFunction = sortFunction;

    this.list = [];
    this.length = 0;
  }

  get = () => {
    const elem = this.list.shift();
    this.length = this.list.length;

    return elem;
  };

  put = (element, withoutSorting) => {
    this.length = this.list.push(element);

    if (!withoutSorting && this.sortFunction) {
      this.sort();
    }

    return this.length;
  };

  putArray = (elements) => {
    elements.forEach((element) => {
      this.length = this.list.push(element);
    });

    this.length = this.list.length;
    this.sort();

    return this.length;
  };

  sort = () => {
    this.list.sort(this.sortFunction);
  };
}

export default Queue;
